const storageType = window.localStorage;

const storage = {
  getToken: () => JSON.parse(storageType.getItem('token')),
  setToken: (token) => storageType.setItem('token', JSON.stringify(token)),
  clearToken: () => storageType.removeItem('token'),
};

export default storage;
